import React, { useEffect, useState } from "react";
import axios from "axios";
import {
 Card,
 CardContent,
 CardActions,
 TextField,
 Button,
 Typography,
} from "@mui/material";

const BookingFeeCard = () => {
 const [bookingFee, setBookingFee] = useState(null);
 const [amount, setAmount] = useState("");
 const [isEditing, setIsEditing] = useState(false);

 useEffect(() => {
  // Fetch the current booking fee when the component mounts
  axios
   .get("https://app-api.carexpert.org.in/api/bookingFee")
   .then((response) => {
    if (response.data) {
     setBookingFee(response.data);
     setAmount(response.data.amount);
    }
   })
   .catch((error) => {
    console.error("Error fetching the booking fee:", error);
   });
 }, []);

 const handleUpdateBookingFee = () => {
  axios
   .put("https://app-api.carexpert.org.in/api/bookingFee/update", { amount })
   .then((response) => {
    setBookingFee(response.data.bookingFee);
    setIsEditing(false);
    alert("Booking fee updated successfully");
   })
   .catch((error) => {
    console.error("Error updating the booking fee:", error);
    alert("Failed to update booking fee");
   });
 };

 return (
  <Card
   sx={{
    maxWidth: 400,
    margin: "20px auto",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: 3,
   }}
  >
   <CardContent>
    <Typography variant="h5" sx={{ marginBottom: "10px", fontWeight: 500 }}>
     Booking Fee
    </Typography>
    {isEditing ? (
     <TextField
      label="Booking Fee Amount"
      type="number"
      value={amount}
      onChange={(e) => setAmount(e.target.value)}
      variant="outlined"
      fullWidth
      sx={{ marginBottom: "20px" }}
     />
    ) : (
     <Typography variant="body1" sx={{ marginBottom: "20px" }}>
      Current Booking Fee: {bookingFee ? bookingFee.amount : "Not Set"}
     </Typography>
    )}
   </CardContent>
   <CardActions>
    {isEditing ? (
     <>
      <Button
       variant="contained"
       color="primary"
       onClick={handleUpdateBookingFee}
      >
       Save
      </Button>
      <Button
       variant="outlined"
       color="secondary"
       onClick={() => setIsEditing(false)}
       sx={{ marginLeft: "10px" }}
      >
       Cancel
      </Button>
     </>
    ) : (
     <Button
      variant="outlined"
      color="primary"
      onClick={() => setIsEditing(true)}
     >
      Edit
     </Button>
    )}
   </CardActions>
  </Card>
 );
};

export default BookingFeeCard;
